/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseContentPageContentBlocksInner } from './DatabaseContentPageContentBlocksInner';
import {
    DatabaseContentPageContentBlocksInnerFromJSON,
    DatabaseContentPageContentBlocksInnerFromJSONTyped,
    DatabaseContentPageContentBlocksInnerToJSON,
} from './DatabaseContentPageContentBlocksInner';
import type { DatabaseContentPageTransitionOptions } from './DatabaseContentPageTransitionOptions';
import {
    DatabaseContentPageTransitionOptionsFromJSON,
    DatabaseContentPageTransitionOptionsFromJSONTyped,
    DatabaseContentPageTransitionOptionsToJSON,
} from './DatabaseContentPageTransitionOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabasePageSizeMode } from './DatabasePageSizeMode';
import {
    DatabasePageSizeModeFromJSON,
    DatabasePageSizeModeFromJSONTyped,
    DatabasePageSizeModeToJSON,
} from './DatabasePageSizeMode';

/**
 * 
 * @export
 * @interface DatabaseContentPage
 */
export interface DatabaseContentPage {
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    ctaCaption?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseContentPage
     */
    locked?: boolean;
    /**
     * when true, the effect (if defined on the database) is hidden on this content page
     * @type {boolean}
     * @memberof DatabaseContentPage
     */
    effectHidden?: boolean;
    /**
     * 
     * @type {DatabaseContentPageTransitionOptions}
     * @memberof DatabaseContentPage
     */
    transitionOptions?: DatabaseContentPageTransitionOptions;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    inlineStyle?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    backgroundColor?: string;
    /**
     * 
     * @type {DatabasePageSizeMode}
     * @memberof DatabaseContentPage
     */
    sizeMode?: DatabasePageSizeMode;
    /**
     * 
     * @type {number}
     * @memberof DatabaseContentPage
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseContentPage
     */
    height?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseContentPage
     */
    aspectRatio?: string;
    /**
     * SEITENEIGENSCHAFTEN VON DER VORGABE UEBERNEHMEN (Betreiber
     * 11.09.2026). Ja = es gelten die gemeinsamen Eigenschaften aus
     * `DatabaseAppearance.pageDefaults` (Groesse, Seitenverhaeltnis,
     * Effekt, Uebergang). Nein = diese Seite bringt ihre eigenen mit,
     * wie bisher — die Maske dafuer erscheint dann wieder an der Seite.
     * 
     * WARUM DER NORMALFALL „NEIN" IST (Betreiber 11.09.2026): „Damit an
     * den bestehenden Datenbanken mit diesem Template nichts kaputt
     * geht." Jede vorhandene Seite behaelt ihre eigenen Einstellungen
     * und sieht aus wie zuvor; wer die Vorgabe will, schaltet sie
     * bewusst ein.
     * 
     * Eine NEU angelegte Seite uebernimmt dagegen, sofern es eine
     * Vorgabe gibt — sonst waere die Vorgabe zwar da, und jede neue
     * Seite ginge trotzdem an ihr vorbei.
     * @type {boolean}
     * @memberof DatabaseContentPage
     */
    inheritPageProperties?: boolean;
    /**
     * LEERE ZEILEN NEHMEN KEINEN PLATZ (Betreiber 12.09.2026,
     * Abnahmekriterium 4 der Minigolfkarte: „Bahntipp ohne Inhalt ist
     * nicht sichtbar UND hinterlaesst keinen Leerraum").
     * 
     * Das Raster einer Seite verteilt die Hoehe gleichmaessig auf seine
     * Zeilen. Blendet ein Anzeigefilter den einzigen Baustein einer
     * Zeile aus, bleibt die Zeile als leeres Band stehen — sichtbar als
     * Luecke mitten auf der Karte.
     * 
     * Ja = Zeilen ohne sichtbaren Baustein werden auf Hoehe 0 gesetzt,
     * die uebrigen teilen sich den Platz. Nein (Vorgabe) = wie bisher,
     * jede Zeile behaelt ihre Hoehe. Bestehende Seiten aendern sich
     * damit um kein Pixel.
     * @type {boolean}
     * @memberof DatabaseContentPage
     */
    collapseEmptyRows?: boolean;
    /**
     * Den gemeinsamen Kopfbereich der Seiten (`DatabaseAppearance.pagesHeader`) auf DIESER Seite uebernehmen. Nein = die Seite zeigt ihn nicht; eine Abschlussseite darf ohne Werbeband auskommen.
     * @type {boolean}
     * @memberof DatabaseContentPage
     */
    inheritPagesHeader?: boolean;
    /**
     * Wie `inheritPagesHeader`, fuer den Fussbereich.
     * @type {boolean}
     * @memberof DatabaseContentPage
     */
    inheritPagesFooter?: boolean;
    /**
     * 
     * @type {Array<DatabaseFieldVisibilityRule>}
     * @memberof DatabaseContentPage
     */
    visibilityRules?: Array<DatabaseFieldVisibilityRule>;
    /**
     * 
     * @type {Array<DatabaseContentPageContentBlocksInner>}
     * @memberof DatabaseContentPage
     */
    contentBlocks?: Array<DatabaseContentPageContentBlocksInner>;
}

/**
 * Check if a given object implements the DatabaseContentPage interface.
 */
export function instanceOfDatabaseContentPage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseContentPageFromJSON(json: any): DatabaseContentPage {
    return DatabaseContentPageFromJSONTyped(json, false);
}

export function DatabaseContentPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseContentPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'ctaCaption': !exists(json, 'ctaCaption') ? undefined : json['ctaCaption'],
        'locked': !exists(json, 'locked') ? undefined : json['locked'],
        'effectHidden': !exists(json, 'effectHidden') ? undefined : json['effectHidden'],
        'transitionOptions': !exists(json, 'transitionOptions') ? undefined : DatabaseContentPageTransitionOptionsFromJSON(json['transitionOptions']),
        'inlineStyle': !exists(json, 'inlineStyle') ? undefined : json['inlineStyle'],
        'backgroundColor': !exists(json, 'backgroundColor') ? undefined : json['backgroundColor'],
        'sizeMode': !exists(json, 'sizeMode') ? undefined : DatabasePageSizeModeFromJSON(json['sizeMode']),
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'aspectRatio': !exists(json, 'aspectRatio') ? undefined : json['aspectRatio'],
        'inheritPageProperties': !exists(json, 'inheritPageProperties') ? undefined : json['inheritPageProperties'],
        'collapseEmptyRows': !exists(json, 'collapseEmptyRows') ? undefined : json['collapseEmptyRows'],
        'inheritPagesHeader': !exists(json, 'inheritPagesHeader') ? undefined : json['inheritPagesHeader'],
        'inheritPagesFooter': !exists(json, 'inheritPagesFooter') ? undefined : json['inheritPagesFooter'],
        'visibilityRules': !exists(json, 'visibilityRules') ? undefined : ((json['visibilityRules'] as Array<any>).map(DatabaseFieldVisibilityRuleFromJSON)),
        'contentBlocks': !exists(json, 'contentBlocks') ? undefined : ((json['contentBlocks'] as Array<any>).map(DatabaseContentPageContentBlocksInnerFromJSON)),
    };
}

export function DatabaseContentPageToJSON(value?: DatabaseContentPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'name': value.name,
        'ctaCaption': value.ctaCaption,
        'locked': value.locked,
        'effectHidden': value.effectHidden,
        'transitionOptions': DatabaseContentPageTransitionOptionsToJSON(value.transitionOptions),
        'inlineStyle': value.inlineStyle,
        'backgroundColor': value.backgroundColor,
        'sizeMode': DatabasePageSizeModeToJSON(value.sizeMode),
        'width': value.width,
        'height': value.height,
        'aspectRatio': value.aspectRatio,
        'inheritPageProperties': value.inheritPageProperties,
        'collapseEmptyRows': value.collapseEmptyRows,
        'inheritPagesHeader': value.inheritPagesHeader,
        'inheritPagesFooter': value.inheritPagesFooter,
        'visibilityRules': value.visibilityRules === undefined ? undefined : ((value.visibilityRules as Array<any>).map(DatabaseFieldVisibilityRuleToJSON)),
        'contentBlocks': value.contentBlocks === undefined ? undefined : ((value.contentBlocks as Array<any>).map(DatabaseContentPageContentBlocksInnerToJSON)),
    };
}

